import { Injectable, signal, computed, effect } from '@angular/core';

export interface LayoutState {
  isSidebarExpanded: boolean;
  isMobile: boolean;
}

// TODO: check if we still need it
@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private readonly storageKey = 'sidebar-expanded';
  private readonly breakpoint = 1440;

  private readonly _isSidebarExpanded = signal<boolean>(this.getInitialSidebarState());
  private readonly _isMobile = signal<boolean>(this.checkIsMobile());

  readonly isSidebarExpanded = this._isSidebarExpanded.asReadonly();
  readonly isMobile = this._isMobile.asReadonly();
  readonly sidebarWidth = computed(() =>
    this._isSidebarExpanded() ? 256 : 64
  );

  constructor() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        this.handleResize();
      });

      this.handleResize();
    }

    effect(() => {
      const isExpanded = this._isSidebarExpanded();

      if (typeof localStorage !== 'undefined') {
        localStorage.setItem(this.storageKey, String(isExpanded));
      }
    });
  }

  private handleResize(): void {
    const isMobileView = this.checkIsMobile();
    const wasMobile = this._isMobile();

    this._isMobile.set(isMobileView);

    // Only auto-adjust if breakpoint changed and user hasn't manually set preference
    if (isMobileView !== wasMobile) {
      const manualPreference = localStorage.getItem(this.storageKey);

      if (!manualPreference) {
        if (isMobileView) {
          this._isSidebarExpanded.set(false);
        } else {
          this._isSidebarExpanded.set(true);
        }
      }
    }
  }

  private checkIsMobile(): boolean {
    if (typeof window !== 'undefined') {
      return window.innerWidth <= this.breakpoint;
    }

    return false;
  }

  toggleSidebar(): void {
    this._isSidebarExpanded.update((current) => !current);
  }

  setSidebarExpanded(expanded: boolean): void {
    this._isSidebarExpanded.set(expanded);
  }

  private getInitialSidebarState(): boolean {
    if (typeof localStorage !== 'undefined') {
      const stored = localStorage.getItem(this.storageKey);

      if (stored !== null) {
        return stored === 'true';
      }
    }

    if (typeof window !== 'undefined') {
      return window.innerWidth > this.breakpoint;
    }

    return true;
  }
}

